import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        refBenutzer: 0,
        login: 0,
        name: '',
        vorname: '',
        kr_nr: 0,
        refKampfflaeche: 0,
        teilnehmer_Prim: 0,
        teilnehmer_WertungTechnik: 0,
        teilnehmer_WertungPraesentation: 0,
        teilnehmer_Abzug: 0,
        refKlasseneinteilung: 0,
        refKlasseneinteilungBezeichnung: '',
        refFormenarten: 0,
        berechtigungenPrim: 0
    }
});

export default store;